<script lang="ts">
  import { setContext } from "svelte";
  import MainPage from "../../components/main-page.svelte";
  import { locale, t } from "../../i18n/index";

  export let language = "ko";

  const campaignSetting = { language };
  setContext("campaignSetting", campaignSetting);

  $: {
    locale.set(campaignSetting.language || "ko");
  }
</script>

<MainPage
  analyticsCampaignType="FORM_EVENT"
  successTitle={$t("formEvent.successTitle")}
  successDescription={$t("formEvent.successDescription")}
  failTitle={$t("formEvent.failTitle")}
  failDescription={$t("formEvent.failDescription")}
/>
